import React from 'react';
import {getHubBaseUrl} from "../../utils/configUtils";

function AgencySSORedirect() {
    window.location.href = `${getHubBaseUrl()}authentication/SingleSignOnServlet`;
    return (
        <div className="container mx-auto pt-8">
            Redirecting to single sign on...
        </div>
    );
}

export default AgencySSORedirect;